import API from "../api/index";
import { useState, useEffect } from "react";


const SelectLecs = () => {
  const [lecs, setLecs] = useState([]);
  const [currenlecs, setCurrentLecs] = useState("");
  
  useEffect(() => {
    API.get_lecs()
      .then((result) => { 
        const selectedLecs = result.data.devices.find(item => item.matricola === result.data.currentLecs)
        if(sessionStorage.getItem("type") === "user") window.sessionStorage.setItem("tipoLecs", selectedLecs.tipo)
        setLecs(result.data.devices);
        setCurrentLecs(result.data.currentLecs);
      })
      .catch((error) => console.error('[SelectLecs] Failed to fetch LECS list:', error));
  }, []);

  const handleSelectChange = (event) => {
    const selectedOptionValue = event.target.value;
    API.set_lecs({ serial_number: selectedOptionValue })
      .then((result) => {
        sessionStorage.removeItem("probeMode")
        window.location.reload()
      })
      .catch((error) => console.error('[handleSelectChange] Failed to set LECS:', error));
  };


  if (!lecs) {
    return null;
  }

  return (
    <select className="form-select centered-options" style={{
      backgroundColor: '#2e2e2e',

    }} onChange={handleSelectChange}>
    {
      lecs.sort((a,b)=>{
          if (a.matricola === currenlecs) return -1
          if (b.matricola === currenlecs) return 1
          return 0
        }).map((item) =>
        item.nomeLecs ? (
          <option key={`lecs-option-${item.matricola}`} className="lecs-option" value={item.matricola}>{item.nomeLecs}</option>
        ) : (
          <option key={`lecs-option-${item.matricola}`} className="lecs-option" value={item.matricola}>{item.matricola}</option>
        )
        
    )}
    </select>
  );
};

export default SelectLecs;
